/**
 * @file: 执行新增任务队列
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../cubeTree/index';
import Utils from '../../utils/util';
import Update from '../../update/index';
import CodiSystem from '../../codiSystem/index';
import { StageEvent } from '../../message/index';
import { runAddTask } from './runAddTask';

function runAddTaskQueue(taskList: Array<AddTask>): Promise<Array<CubeId>> {
    return new Promise<Array<CubeId>>((resolve: (cubes: Array<CubeId>) => void, reject: () => void): void => {
        recursiveRun([], taskList, (addCubeIds: Array<CubeId>) => {
            CodiSystem.updateAllAsync();
            resolve(addCubeIds);
        });
    });
}

async function recursiveRun(addCubeIds: Array<CubeId>, taskList: Array<AddTask>, done): Promise<void> {
    if (!taskList.length) {
        done(addCubeIds);
        return;
    }

    let currentTask: AddTask = taskList.shift();
    let cubeIds: Array<CubeId> = await runAddTask(currentTask);

    addCubeIds = addCubeIds.concat(cubeIds);
    recursiveRun(addCubeIds, taskList, done);
}

export {
    runAddTaskQueue
};
